import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

export const DestinationCard = ({ destination, className = '' }) => {
  const { lang, t } = useLanguage();

  return (
    <Link
      to={`/destinations/${destination.slug}`}
      data-testid={`destination-card-${destination.slug}`}
      className={`group relative block overflow-hidden bg-navy ${className}`}
    >
      <img
        src={destination.image}
        alt={destination.name[lang]}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover opacity-90 transition-transform duration-700 ease-out group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-navy-dark/90 via-navy-dark/20 to-transparent" />
      <div className="relative flex h-full flex-col justify-end p-6 md:p-8">
        <h3 className="font-heading text-2xl text-ivory md:text-3xl">{destination.name[lang]}</h3>
        <p className="mt-2 max-w-md text-sm leading-relaxed text-ivory/70">{destination.short[lang]}</p>
        <span className="mt-5 inline-flex w-fit items-center gap-2 border-b border-gold pb-1 text-[11px] font-semibold uppercase tracking-[0.25em] text-gold transition-colors duration-300 group-hover:text-gold-light">
          {t.home.explore}
          <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1.5" />
        </span>
      </div>
    </Link>
  );
};

export default DestinationCard;
